import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';
import i18n from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getErrorMessageFromAPI } from '../../../utilz';
import {
  checkProjectNameIsExistsFail,
  checkProjectNameIsExistsSuccess,
  createUpdateProjectInFail,
  createUpdateProjectInSuccess,
  getProcurementProjectListInFail,
  getProcurementProjectListInSuccess,
  getProjectCopyInFail,
  getProjectCopyInSuccess,
  getTenderByProjectListInFail,
  getTenderByProjectListInSuccess,
  getUserProcurementInFail,
  getUserProcurementInSuccess,
} from './ProcurementProjectActions';
import {
  checkProjectNameEffects,
  createUpdateProjectEffect,
  getProjectCopyEffect,
  getProjectListEffect,
  getTenderByProjectEffect,
  getUserProcurementEffect,
} from './ProcurementProjectEffects';
import ProcurementProjectType from './ProcurementProjectTypes';

export const procurementProject = (state) => state.procurementProject;

function removeEmptyObjects(obj) {
  Object.keys(obj).forEach((key) => {
    if (typeof obj[key] === 'object') {
      removeEmptyObjects(obj[key]);
    } else if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
      delete obj[key];
    }
  });
  return obj;
}

function* getProjectListAction() {
  try {
    const { projectList } = yield select(procurementProject);
    const requestParams = yield call(removeEmptyObjects, projectList.req);
    const { data } = yield call(getProjectListEffect, requestParams);
    yield put(getProcurementProjectListInSuccess({ data: data }));
  } catch (e) {
    yield put(getProcurementProjectListInFail({ message: getErrorMessageFromAPI(e) }));
  }
}

function* checkProjectNameAction(request) {
  try {
    const data = yield call(checkProjectNameEffects, request.payload);
    yield put(checkProjectNameIsExistsSuccess({ data: data }));
  } catch (e) {
    yield put(checkProjectNameIsExistsFail({ message: getErrorMessageFromAPI(e) }));
  }
}

function* getUserProcurementAction() {
  try {
    const { userProcurement } = yield select(procurementProject);
    const requestParams = yield call(removeEmptyObjects, userProcurement.req);
    const { data } = yield call(getUserProcurementEffect, requestParams);
    yield put(getUserProcurementInSuccess({ data: data }));
  } catch (e) {
    yield put(getUserProcurementInFail({ message: getErrorMessageFromAPI(e) }));
  }
}

function* getTenderByProjectAction() {
  try {
    const { tenderByProjectList } = yield select(procurementProject);
    const requestParams = yield call(removeEmptyObjects, tenderByProjectList.req);
    const { data } = yield call(getTenderByProjectEffect, requestParams);
    yield put(getTenderByProjectListInSuccess({ data: data }));
  } catch (e) {
    yield put(getTenderByProjectListInFail({ message: getErrorMessageFromAPI(e) }));
  }
}

function* createUpdateProjectAction() {
  try {
    const { createUpdateProject } = yield select(procurementProject);
    const { data } = yield call(createUpdateProjectEffect, createUpdateProject.req);
    yield put(createUpdateProjectInSuccess({ data: data }));
  } catch (e) {
    yield put(createUpdateProjectInFail({ message: getErrorMessageFromAPI(e) }));
  }
}

function* projectCopyAction() {
  try {
    const { projectCopy } = yield select(procurementProject);
    const requestParams = yield call(removeEmptyObjects, projectCopy.req);
    const { data } = yield call(getProjectCopyEffect, requestParams);
    if (data === 'Error') {
      throw `${i18n.t('translation:default.fields.toCopyError')}`;
    }
    yield call(showNotification, {
      type: NOTIFICATION_TYPES.SUCCESS,
      message: i18n.t('translation:default.fields.copyProjectSuccessfully'),
    });
    yield put(getProjectCopyInSuccess({ data: data }));
  } catch (e) {
    const errMsg = getErrorMessageFromAPI(e, `${i18n.t('translation:default.fields.toCopyError')}`);
    yield call(showNotification, {
      type: NOTIFICATION_TYPES.ERROR,
      message: errMsg,
    });
    yield put(getProjectCopyInFail({ message: errMsg }));
  }
}

export default function* procurementProjectSaga() {
  yield takeLatest(ProcurementProjectType.GET_PROCUREMENT_PROJECT_LIST, getProjectListAction);
  yield takeLatest(ProcurementProjectType.CHECK_PROJECT_NAME_IS_EXISTS, checkProjectNameAction);
  yield takeLatest(ProcurementProjectType.GET_USER_PROCUREMENT, getUserProcurementAction);
  yield takeLatest(ProcurementProjectType.GET_TENDER_BY_PROJECT_LIST, getTenderByProjectAction);
  yield takeLatest(ProcurementProjectType.CREATE_UPDATE_PROJECT, createUpdateProjectAction);
  yield takeLatest(ProcurementProjectType.CREATE_PROJECT_COPY, projectCopyAction);
}
